import { observer } from 'mobx-react-lite';

import { cn } from '@workspace/ui/lib/utils';

import { useGlobal } from '~/hooks/useGlobal';
import type { Category } from '~/stores/CategoriesStore';

interface Props {
  category: Category;
}

/**
 * Trust row of the DubaiExpress home: one item per child category of the CMS
 * block, with the child's preview image as the icon, its name as the bold
 * value and its preview text as the label. One row on desktop, two columns
 * on mobile.
 */
const TrustRowDEView = ({ category }: Props) => {
  const { isMobile } = useGlobal();
  const items = category.subcategory;

  if (items.length === 0) {
    return null;
  }

  return (
    <section
      className={cn(
        'mt-4 rounded-[16px] bg-[#F7F7F7]',
        isMobile
          ? 'grid grid-cols-2 gap-x-2 gap-y-2.5 p-3'
          : 'flex items-center px-5 py-3.5',
      )}
    >
      {items.map((item, index) => (
        <div
          key={item.id}
          className={cn(
            'flex min-w-0 items-center gap-2',
            isMobile ? 'min-h-5' : 'flex-1 justify-center px-1.5',
            !isMobile &&
              index > 0 &&
              'border-0 border-[rgba(0,0,0,0.12)] border-l border-solid',
          )}
        >
          {item.previewImage && (
            <img
              src={item.previewImageThumb || item.previewImage}
              alt=""
              className="h-5 w-auto max-w-7 shrink-0 object-contain"
            />
          )}
          <span
            className={cn(
              'block min-w-0 text-[#141415] leading-4! tracking-[-0.01em]',
              isMobile
                ? 'line-clamp-2 text-[12px]'
                : 'text-pretty text-center text-[clamp(11px,1.05vw,15px)]',
            )}
          >
            <strong className="font-semibold!">{item.name}</strong>{' '}
            {item.previewText}
          </span>
        </div>
      ))}
    </section>
  );
};

export const TrustRowDE = observer(TrustRowDEView);
